const TOOLTIP_CLASSNAME = 'tooltip';


export function setupMobileTooltips() {
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;

    if (target.classList.contains(TOOLTIP_CLASSNAME)) {
      const rect = target.getBoundingClientRect();
      const isClickInside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!isClickInside) {
        (document.activeElement as HTMLElement)?.blur();
      }
    }
  });
}
